function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 43.386,35.236 V 4.949 c 0,-2.209 -1.791,-4 -4,-3.999 -2.209,0 -4,1.79 -4,4 V 35.236 H 5.1000001 c -2.2099998,0 -3.9999998,1.791 -3.9999998,4 -0.001,2.209 1.791,4 3.9989998,4 H 35.386 v 30.287 c 0,2.208 1.791,4 4,3.999 1.104,0 2.104,-0.447 2.827,-1.171 0.725,-0.725 1.173,-1.725 1.173,-2.829 V 43.236 h 30.286 c 1.104,0 2.104,-0.448 2.828,-1.172 0.725,-0.725 1.172,-1.725 1.172,-2.828 0,-2.209 -1.791,-4 -4,-4 z"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "-0.614 -0.764 80 80",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.729f8d67.svg";
export { ForwardRef as ReactComponent };